// removed by extract-text-webpack-plugin
module.exports = {"small":"only screen and (min-width: 481px)","medium":"only screen and (min-width: 768px)","large":"only screen and (min-width: 993px)","xlarge":"only screen and (min-width: 1201px)","lifetimeStatsContainer":"lifetimeStatsContainer-3_OSJ","pageTitle":"pageTitle-1jlDZ","pageLoader":"pageLoader-2XVtp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/workouts/dashboard/lifetime/_lifetimeStats.css
// module id = 1287
// module chunks = 1